import React, { useState, useEffect, useCallback } from 'react';
import { Container, Row, Col, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import queryString from 'query-string';
import axios from 'axios';

import '../App.css';

import ImageGalleryView from './image-gallery-view';
import GarmentManager from '../garment/garment-manager.js';
import EditAlbum from './edit-album';
import CreateAlbumModal from './create-album-modal';
import constants from '../../const.js';

function GalleryView(props) {

    var params = queryString.parse(props.location?.search);

    if(props?.match == null){
        params.id = props.name
    }
    else{
        params.id = props.match.params.id
    }
    params.displayAlbum = true;

    // Extract gallery folder name from URL path
    let galleryFolderName = params.id;
    // Extract album folder name from query parameter
    let albumFolderName = params.album || null;

    // State for album data
    const [album, setAlbum] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isAdmin, setIsAdmin] = useState(false);
    // Standalone gallery has no actor context, so it hosts its own Garment Manager (actor is picked in its editor)
    const [garmentSource, setGarmentSource] = useState(null);
    const sendToGarment = useCallback((image) => setGarmentSource({ url: image.src, name: image.key.split('/').pop() }), []);
    const garmentHandler = props.onSendToGarment || (isAdmin ? sendToGarment : undefined);

    const API_URL = constants.DATA1_API_URL || 'http://localhost:5050';

    // Only admins can create albums
    useEffect(() => {
        const checkAdminStatus = async () => {
            try {
                const token = localStorage.getItem('token');
                if (!token) {
                    setIsAdmin(false);
                    return;
                }

                const response = await axios.get(
                    `${constants.USER_API_URL}/auth/authenticated`,
                    { headers: { 'Authorization': token } }
                );

                if (response.data && response.data.perm) {
                    setIsAdmin(response.data.perm.some(p => p.role && p.role.id === 1));
                }
            } catch (error) {
                console.error('Error checking admin status:', error);
                setIsAdmin(false);
            }
        };

        checkAdminStatus();
    }, []);

    // Fetch album data
    useEffect(() => {
        const fetchAlbumData = async () => {
            try {
                setLoading(true);
                setError(null);

                if (!galleryFolderName || !albumFolderName) {
                    throw new Error('Gallery or album folder name is missing');
                }

                // Fetch album data using folder-based IDs
                const response = await axios.get(
                    `${API_URL}/gallery/${encodeURIComponent(galleryFolderName)}/album/${encodeURIComponent(albumFolderName)}`,
                    {
                        headers: {
                            'Authorization': localStorage.getItem('token') || ''
                        }
                    }
                );

                if (response.data) {
                    setAlbum(response.data);
                } else {
                    // Fallback to mock data if API returns empty
                    setAlbum({
                        folder_name: albumFolderName,
                        gallery_folder_name: galleryFolderName,
                        title: albumFolderName,
                        description: '',
                        date: "2023-10-10T00:00:00.000Z",
                        actors: []
                    });
                }
            } catch (err) {
                console.warn('Error fetching album data, using mock data:', err);
                // Use mock data as fallback
                setAlbum({
                    folder_name: albumFolderName,
                    gallery_folder_name: galleryFolderName,
                    title: albumFolderName || 'Unknown Album',
                    description: '',
                    date: "2023-10-10T00:00:00.000Z",
                    actors: []
                });
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchAlbumData();
    }, [galleryFolderName, albumFolderName]);

    const handleAlbumUpdated = () => {
        // Refresh album data after edit
        const fetchAlbumData = async () => {
            try {
                const response = await axios.get(
                    `${API_URL}/gallery/${encodeURIComponent(galleryFolderName)}/album/${encodeURIComponent(albumFolderName)}`,
                    {
                        headers: {
                            'Authorization': localStorage.getItem('token') || ''
                        }
                    }
                );

                if (response.data) {
                    setAlbum(response.data);
                }
            } catch (err) {
                console.warn('Error refreshing album data:', err);
            }
        };

        fetchAlbumData();
    };

    // Use album data if available, otherwise use defaults
    const galOBJ = album || {
        folder_name: albumFolderName,
        gallery_folder_name: galleryFolderName,
        title: albumFolderName || 'Unknown Album',
        actors: [],
        date: "2023-10-10T00:00:00.000Z"
    }
    

    document.title = `${galOBJ.folder_name || galOBJ.id}|${galOBJ.title}`
    let date = dayjs(galOBJ.date);
    

    var actorElem = [];
    const actorsToDisplay = Array.isArray(galOBJ.actors) ? galOBJ.actors : [];
    for (var i = 0; i < actorsToDisplay.length; i++) {
        var actorUrl = `/actor/${actorsToDisplay[i].id}`;
        if (i >= 0 && i < actorsToDisplay.length - 1) {
            actorElem.push(<Link key={i} to={actorUrl}><span style={{ fontSize: "14px", marginRight: "5px" }}>{actorsToDisplay[i].name},  </span></Link>);
        }
        else {
            actorElem.push(<Link key={i} to={actorUrl}><span style={{ fontSize: "14px", marginRight: "5px" }}>{actorsToDisplay[i].name}</span></Link>);
        }
    }

    if (loading) {
        return (
            <Container style={{ maxWidth: `${window.innerWidth}px`, marginTop: "50px", textAlign: "center" }}>
                <Spinner animation="border" role="status" />
                <p style={{ marginTop: "10px" }}>Loading album...</p>
            </Container>
        );
    }

        return ( <>
        <Container fluid>
            {console.log(window.innerWidth)}

        {/* {scene.scene.id == 0 && props.error !== '' ? <Redirect to='/scenes'></Redirect> : <></>} */}
        <Container fluid>
            <Row style={{ marginTop: "50px" }} className="justify-content-between">
                <Col>
                    <h2>{galOBJ.title}</h2>
                </Col>
                <Col style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "10px" }}>
                    {isAdmin && galleryFolderName && <CreateAlbumModal galleryId={galleryFolderName} onSave={() => window.location.reload()} />}
                    {galleryFolderName && albumFolderName && <EditAlbum albumId={albumFolderName} galleryId={galleryFolderName} onSave={handleAlbumUpdated} />}
                </Col>
            </Row>
            <Row style={{ marginTop: "5px" }}>{actorElem}</Row>
            <Row><div className="text-muted" style={{ fontSize: "15px" }}>{date.format("D-MMM-YYYY")}</div></Row>
            <Row className="justify-content-between">
                <div style={{ width: "100%", height: "100%", }}>
                    <ImageGalleryView id={params.id} params={params} onSendToGarment={garmentHandler}/>
                    {!props.onSendToGarment && isAdmin && <GarmentManager show={false} sourceImage={garmentSource} onSourceImageHandled={() => setGarmentSource(null)} />}
                </div>
            </Row>
            <Row>
                <Col sm={3} md={4} style={{ marginLeft: "20px" }}>
                    
                   
                    <Row className="">
                        {/* <a href={`/scenes?site=${props.scene.site.siteId}`} className="site site-scene">
                            <div className="site-left-box site">{props.scene.site.shortname}</div>
                            <div className="site-right-box site">{props.scene.site.name}</div>
                        </a> */}
                        {/* {props.scene.movie.id != 0 ?
                            <a href={`/scenes?movie=${props.scene.movie.id}`} className="site site-scene">
                                <div className="site-left-box site">{props.scene.movie.scenesNumber}</div>
                                <div className="site-right-box site">{props.scene.movie.title}</div>
                            </a> : <div />} */}
                    </Row>
                </Col>
                <Col>
                    {/* <Row className="justify-content-between">
                        <Col><h3>Tags</h3></Col>
                        {props.perms.some(e => e.role.id === 12) ? <Col><UploadFile sceneId={scene.scene.id} /></Col> : null}
                        {props.perms.some(e => e.role.id === 2) ? <Col><EditScene sceneView={true} sceneId={scene.scene.id} /></Col> : null}
                        <Col><button type="button" className={`btn btn-sm btn-success`} onClick={refreshScene}>Refresh</button></Col>
                    </Row> */}
                    {/* {!props.isFetchingSceneTag ? category.map((cat, idx) => (
                        <Row key={`${cat}${idx}`}>
                            <Col xs={3} sm={3} md={2}>{cat}</Col>
                            <Col>
                                <Row>
                                    {helper.findTag(TAGS.SCENECATEGORY, cat, props.sceneTag).map((tag) =>
                                    (<div key={tag.id} className="m-1 badge badge-secondary">
                                        <span> <Link style={{ color: "white" }} to={`/scenes?tag=${tag.id}`}>{tag.name}</Link> </span>
                                    </div>))}
                                </Row>
                            </Col>
                        </Row>)) : <div><SpinnerLoad></SpinnerLoad></div>} */}
                </Col>
            </Row>
            <Row>
                {/* <div className="text-left mt-4" style={{ fontSize: "16px" }}>{scene.scene.description}</div> */}
            </Row>
            {/* <Row><a href={`${constants.CONTENT_DOMAIN}dload/${scene.scene.videoUrl}${token}`} onClick={()=>props.downloadHistory(scene.scene.id)}>Download</a></Row> */}
            {/* <Row><RelatedScenes /></Row> */}
        </Container>

    </Container></>)
}

export default GalleryView;